"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigationFooter = exports.useNavigation = exports.useMeta = exports.useMedia = exports.useI18n = exports.useDocument = exports.useCustomProperties = exports.useContentElement = exports.useCategories = exports.useBreadcrumbs = exports.useAppearance = void 0;
var _react = require("react");
var _context = _interopRequireDefault(require("./context"));
const useDocument = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.document;
};
exports.useDocument = useDocument;
const useMedia = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.media;
};
exports.useMedia = useMedia;
const useMeta = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.meta;
};
exports.useMeta = useMeta;
const useCategories = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.categories;
};
exports.useCategories = useCategories;
const useBreadcrumbs = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.breadcrumbs;
};
exports.useBreadcrumbs = useBreadcrumbs;
const useAppearance = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.appearance;
};
exports.useAppearance = useAppearance;
const useI18n = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.i18n;
};
exports.useI18n = useI18n;
const useNavigation = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.navigation;
};
exports.useNavigation = useNavigation;
const useCustomProperties = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.customProperties;
};
exports.useCustomProperties = useCustomProperties;
const useContentElement = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.contentElement;
};
exports.useContentElement = useContentElement;
const useNavigationFooter = () => {
  const typo3Context = (0, _react.useContext)(_context.default);
  return typo3Context === null || typo3Context === void 0 ? void 0 : typo3Context.navigationFooter;
};
exports.useNavigationFooter = useNavigationFooter;